import React from 'react'
//react-icons
import { BiLogoTelegram } from 'react-icons/bi'
import { BsTwitter } from 'react-icons/bs'
import { MdMarkEmailUnread } from 'react-icons/md'
//type animation
import { TypeAnimation } from 'react-type-animation'
//motion
import { motion } from 'framer-motion'
//variants'
import { fadeIn } from '../variants';
//pdf
import whitepaper from '../assets/images/whitepaper.pdf'

const Socials = () => {
    return (
        <div className='font-mooli' id='socails'>
            <div className='w-full flex md:flex-row flex-col justify-center min-h-screen  items-center gap-12 pt-8 pb-44 px-12'>
                <div className='w-full flex flex-col justify-center items-center md:w-1/2'>
                    <motion.h1
                     variants={fadeIn('down', 0.3)}
                     initial='hidden'
                     whileInView={'show'}
                     viewport={{ once: false, amount: 0.7 }}
                     className='text-4xl md:text-7xl'>
                        Connect with us
                    </motion.h1>
                    {/* <motion.a
                variants={fadeIn('down', 0.3)}
                initial='hidden'
                whileInView={'show'}
                viewport={{ once: false, amount: 0.7 }}
                href = {whitepaper} target = "_blank"
                className='py-4 mt-10 px-4 hover:scale-105 transition-all rounded-2xl flex text-lg max-w-sm flex-col justify-center items-center shadow-lg backdrop-blur-2xl  bg-white/20'
                >White Paper</motion.a> */}


                </div>
                <div className='w-full md:w-1/2 flex flex-col space-y-12'>
                    {/* Telegram */}
                    <motion.a
                    href='https://t.me/TIME_ERC20'
                    target='blank'
                        variants={fadeIn('up', 0.3)}
                        initial='hidden'
                        whileInView={'show'}
                        viewport={{ once: false, amount: 0.7 }}
                        className='py-4 px-4 rounded-2xl flex flex-col justify-center items-center shadow-lg backdrop-blur-2xl hover:scale-95 transition-transform bg-white/20'>
                        <BiLogoTelegram size={44} />
                        <h1 className='font-bold text-xl'>Telegram</h1>
                    </motion.a>
                    {/* Twitter */}
                    <motion.a
                    href='https://twitter.com/TIME_ERC20'
                    target='blank'
                        variants={fadeIn('up', 0.3)}
                        initial='hidden'
                        whileInView={'show'}
                        viewport={{ once: false, amount: 0.7 }}
                        className='py-4 px-6 rounded-2xl flex flex-col justify-center items-center shadow-lg backdrop-blur-2xl hover:scale-95 transition-transform bg-white/20'>
                        <BsTwitter size={44} />
                        <h1 className='font-bold text-xl '>Twitter</h1>
                    </motion.a>
                    {/* Email */}
                    <motion.div
                   onClick={() =>
                    window.open(
                      `mailto:info.timetoken@gmail.com?subject=${encodeURIComponent(
                       
                      )}`
                    )
                  }
        
        
           
                        variants={fadeIn('up', 0.3)}
                        initial='hidden'
                        whileInView={'show'}
                        viewport={{ once: false, amount: 0.7 }}
                        className='py-4 px-8 rounded-2xl flex flex-col justify-center items-center shadow-lg backdrop-blur-2xl hover:scale-95 transition-transform bg-white/20'>
                        <MdMarkEmailUnread size={44} />
                        <h1 className='font-bold text-xl'>Email</h1>
                    </motion.div>

                </div>



            </div>



        </div>
    )
}

export default Socials
